import { useLazyQuery, useQuery } from "@apollo/client";
import { CUSTOMER_ADDRESSES } from "../customer-address.queries";
import {
  CustomerAddressesQuery,
  CustomerAddressesQueryVariables,
} from "../../../__generated__/CustomerAddressesQuery";

export const useCustomerAddresses = (variables: CustomerAddressesQueryVariables) => {
  return useQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>(
    CUSTOMER_ADDRESSES,
    { variables }
  );
};

export const useLazyCustomerAddresses = () => {
  return useLazyQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>(
    CUSTOMER_ADDRESSES
  );
};
